module.exports = __webpack_public_path__ + "static/overview-pc-a3b7786cae167d75a39a0a4a80b0beb9.png";